// extracted by mini-css-extract-plugin
module.exports = {"navLogo":"side-nav_navLogo_2SzmB","notificationIcon":"side-nav_notificationIcon_3kVX2","navTitle":"side-nav_navTitle_QYHug","navSubtitle":"side-nav_navSubtitle_1J_I8"};